<template>
    <div></div>
</template>

<script>
export default {
    //redirects to the first page
    created() {
        if(!this.isSupervisor && this.isMobile) {
            this.$router.push('/mobiledashboard')
        }
        else {
            this.$router.push('/webshops')
        }
    },
    data() {
        return {
            isMobile: 
                navigator.userAgent.match(/Android/i) ||
                navigator.userAgent.match(/webOS/i) ||
                navigator.userAgent.match(/iPhone/i) ||
                navigator.userAgent.match(/iPad/i) ||
                navigator.userAgent.match(/iPod/i) ||
                navigator.userAgent.match(/BlackBerry/i) ||
                navigator.userAgent.match(/Windows Phone/i),
        }
    },
    computed: {
        isSupervisor() {
            return this.$store.state.shop
        }
    },
}
</script>

<style scoped lang="scss">

</style>